/**
 * Bridge from the fetch layer to the auth layer.
 *
 * apiService calls notifySessionExpired() when a request is still 401 after a
 * forced token refresh; useAuthQuery registers the handler that signs the user
 * out. Concurrent 401s collapse into a single handler run.
 */
let handler = null
let inFlight = false

export function registerSessionExpiredHandler(fn) {
  handler = fn
  return () => {
    if (handler === fn) handler = null
  }
}

export function notifySessionExpired() {
  if (!handler || inFlight) return
  inFlight = true
  Promise.resolve(handler()).finally(() => {
    inFlight = false
  })
}
